import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  a {
    font-size: 1rem;
    color: #fff;

    &:hover {
      color: #ff8a7a;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/CsvDownloadLink/component.styles.js